import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  private isMiniCartVisible = new BehaviorSubject<boolean>(false);
  isMiniCartVisible$ = this.isMiniCartVisible.asObservable();

  private isAuthModalVisible = new BehaviorSubject<boolean>(false);
  isAuthModalVisible$ = this.isAuthModalVisible.asObservable();

  constructor() { }

  openMiniCart(): void {
    this.isMiniCartVisible.next(true);
  }

  closeMiniCart(): void {
    this.isMiniCartVisible.next(false);
  }

  openAuthModal(): void {
    this.isAuthModalVisible.next(true);
  }

  closeAuthModal(): void {
    this.isAuthModalVisible.next(false);
  }
}
